import { VerticalList } from './components';

import styles from './UILab.module.scss';
import '@components/mixins/commonStyles.scss';
import { UILabComponent } from './UILabPageContainer';
import { ComponentItem } from './components/ComponentItem/ComponentItem';
import { TextLink } from '@components/TextLink';
import { LinkTarget } from '@components/TextLink/TextLink';

interface UILabPageProps {
    componentList: UILabComponent[];
}

export function UILabPage({ componentList }: UILabPageProps) {
    return (
        <div className={styles.root}>
            <div className={'font_h2'}>UI lib</div>
            <div className={styles.content}>
                <div className={styles.sidebar}>
                    <VerticalList data={componentList} />
                </div>
                <div className={styles.components}>
                    {componentList &&
                        componentList.map(({ id, title, url, Component, componentProps, fields }) => (
                            <ComponentItem
                                key={id}
                                id={id}
                                title={title}
                                Component={Component}
                                componentProps={componentProps}
                                fields={fields}
                            >
                                <TextLink
                                    target={LinkTarget.SELF}
                                    link={`/uilab${url}`}
                                    label={'Details...'}
                                />
                            </ComponentItem>
                        ))}
                </div>
            </div>
        </div>
    );
}
